import { register } from '@shopify/theme-sections'
import { freezeScroll, releaseScroll } from '../core/freeze-scroll'
import Breakpoints from '../core/breakpoints-tailwind'
import threshold from '../core/scroll-threshold'
import ClickOutside from 'vue-click-outside'

register('header', {
  onLoad() {
    this.vue = new Vue ({
      el: this.container,
      delimiters: ['${', '}'],
      data: {
        searchVisible: false,
        scrolled: false,
        navVisible: false,
        images: [],
        selectedShopItemIndex: -1
      },
      directives: {
        ClickOutside
      },
      watch: {
        searchVisible (visible) {
          this.$nextTick(() => {
            if (visible) {
              this.$refs.searchInput.focus({ preventScroll: true })
            } else {
              this.$refs.searchIcon.focus({ preventScroll: true })
            }
          })
        },
        navVisible(visible) {
          if(visible) {
            this.searchVisible = false;
          }
          if (!Breakpoints.is('md+')) {
            if(visible) {
              let offset = Math.max(0, this.$refs.headerContent.getBoundingClientRect().top);
              if (this.$refs.shopNav) this.$refs.shopNav.style.top = offset + 'px'
              freezeScroll()
            } else {
              releaseScroll()
            }
          }
        },
      },

      mounted() {
        this.$nextTick(() => {
          Breakpoints.on('md+', {
            enter: () => {
              this.navVisible = false;
              releaseScroll();
            }
          })

          threshold({
            pxOffset: () => {
              return this.$refs.headerContent.getBoundingClientRect().top + this.$refs.headerContent.clientHeight;
            },
            below: () => {
              this.scrolled = true;
            },
            above: () => {
              this.scrolled = false;
            },
          })
        })
      }
    })
  },

  onUnload() {
    this.vue.destroy()
  }

});
